import { Component, OnInit, Input, EventEmitter, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormGroupFilters } from 'app/shared/table-filters/model/table-filter.model';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-select-search-simple',
    templateUrl: './select-search-simple.component.html',
    styleUrls: ['./select-search-simple.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, NgSelectModule]
})
export class SelectSearchSimpleComponent implements OnInit, OnChanges {
  @Input() filter: FormGroupFilters;
  @Input() form: UntypedFormGroup;
  @Output() changeItem = new EventEmitter();

  list: any;
  constructor() { }

  ngOnInit() {
    this.generateList();
  }

  ngOnChanges() {
    if (this.filter.type === 'select-search-simple') {
      this.generateList();
    }
  }

  changeItems(id) {
    this.changeItem.emit({
      name: this.filter.name,
      id: (id !== undefined) ? id.id : null
    });
  }

  generateList() {
    this.list = this.filter.options;
  }
}
